import React from 'react';
import Relay from 'react-relay';
import RelayStore from '../../RelayStore';

import SportPanel from '../../components/SportPanel';
import NewSportMutation from '../../mutations/Sport/NewSportMutation';

class AddSport extends React.Component {

  constructor(props) {
    super(props);
  }

  onAddSport(sport){

  	const { relay, langList, lang } = this.props.location.state;
		const { viewer } = this.props; 

  	sport.levels.forEach(level => {
      langList.forEach(langInList => {
        if (typeof level[langInList] == 'undefined' || level[langInList] == "")
          level[langInList] = level[lang];
      });
    });

    try {
      sport.levels.forEach(level => {  
        Object.keys(level).forEach(key => {
          if (isNaN(level[key].skillLevel))
            throw new Error('The skill levels should be numbers')
          
          level[key].skillLevel = parseInt(level[key].skillLevel)
        })
      })
    }
    catch(err) {
      alert(err)
      return ;
    }

	  sport.positions.forEach(position => {
      langList.forEach(langInList => {
        if (typeof position[langInList] == 'undefined' || position[langInList] == "")
          position[langInList] = position[lang];
      });
    });

    sport.certificates.forEach(certificate => {
      langList.forEach(langInList => {
        if (typeof certificate.name[langInList] == 'undefined' || certificate.name[langInList] == "" || certificate.name[langInList] == null)
          certificate.name[langInList] = certificate.name[lang];
      });
    });

    langList.forEach(langInList => {
      if (typeof sport.name[langInList] == 'undefined' || sport.name[langInList] == "")
        sport.name[langInList] = sport.name[lang];
    });

  	let mutation = new NewSportMutation({sport, viewer});

  	RelayStore.commitUpdate( mutation, {
		onFailure: (error) => {
			console.log('error', error.getError());
			alert('Add Failed')
		},
		onSuccess: (response) => {
			console.log('success', response);
			alert('Add Success');
		}
  	});
  }


  render() {
  	const { sport, lang, langList } = this.props.location.state;
    return (
		<div className="panel" style={{marginTop:20}}>
		    <SportPanel 
		      sport={sport} 
		      lang={lang}
		      langList={langList}
		      onUpdateSport={this.onAddSport.bind(this)}
		      text="New"/>
		</div>
    );
  }

}

export default Relay.createContainer(AddSport, {
  fragments: {
		sportStatusList: () => Relay.QL`fragment on __Type {enumValues {name description}}`,
    viewer: () => Relay.QL`
      fragment on Viewer {
				supportedLanguages,
        sports (last: 1000) {
          edges {
            node {
              id,
              name {
                FR,
                EN,
                DE,
                ES
              },
              positions {
                FR,
                EN,
                DE,
                ES
              },
              logo,
              certificates {
                name {
                  FR,
                  EN,
                  DE,
                  ES
                }
              },
              levels {
                FR {
                  name,
                  description,
                  skillLevel
                },
                EN {
                  name,
                  description,
                  skillLevel
                },
                DE {
                  name,
                  description,
                  skillLevel
                },
                ES {
                  name,
                  description,
                  skillLevel
                },
              }
              status,
            }
          }
        }
        ${NewSportMutation.getFragment('viewer')}
			}
		`
	}
});


// WEBPACK FOOTER //
// ./src/pages/Sport/AddSport.js